// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".desktop_type-module__menu--1K7Ai{display:inline-block;width:100%;margin-bottom:15px;font-size:13px;border:1px solid lightgrey;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;float:left}@media screen and (max-width: 62.5625em){.desktop_type-module__menu--1K7Ai{display:none;opacity:0}}.desktop_type-module__separator--1hfyM{border:0px solid lightgrey;margin:0px;background-color:lightgrey;height:1px;width:100%;float:left}\n", ""]);
// Exports
exports.locals = {
	"menu": "desktop_type-module__menu--1K7Ai",
	"separator": "desktop_type-module__separator--1hfyM"
};
module.exports = exports;
